<div class="filter-element d-none d-md-flex">
  <div #dropDownTableau="ngbDropdown" ngbDropdown>
    <button (focus)="dropDownTableau.open()"
            class="btn btn-outline-primary"
            id="dropDownTableau" ngbDropdownAnchor>
      <span translate>Functions</span>
    </button>

    <div aria-labelledby="dropDownTableau" ngbDropdownMenu>
      <button (click)="onEditPage()" [disabled]="disableEditButton" ngbDropdownItem>
        <span class="fa-solid fa-pen"></span>
        <span translate>Edit page</span>
      </button>
    </div>
  </div>
</div>